"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfoDialogDrawer = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductInfoDialogDrawer = ({
  open,
  onClose,
  placement = 'right',
  title,
  children,
  PaperProps
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Drawer, {
    "data-testid": getTestId(_constants.PRODUCT_INFO_DIALOG_DRAWER),
    open: open,
    anchor: placement,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      elevation: 0,
      ...PaperProps,
      children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h5",
          component: "h5",
          children: title
        })
      }) : null, children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CloseButton, {
        color: "default",
        variant: "text",
        "data-testid": getTestId(_constants.PRODUCT_INFO_DIALOG_DRAWER_CLOSE_BUTTON),
        onClick: onClose,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
          fontSize: "small",
          color: "inherit"
        })
      })]
    })
  });
};
exports.ProductInfoDialogDrawer = ProductInfoDialogDrawer;